import React, { useEffect, useRef, useState } from "react";
import { SubmitHandler } from "react-hook-form";
import { AnimatePresence } from "framer-motion";

import { copy } from "shared/assets";
import { Button, Label } from "shared/components";
import {
  FilterContainer,
  FilterHeader,
  FilterFooter,
  FilterContent,
  FilterReset,
  StyledCloseButton,
} from "./styles";
import { FormBuilder } from "../Form";
import { IFormFields } from "shared/types";

const mobileFilterAnimationProps = {
  transition: { type: "spring", bounce: 0, duration: 0.15 },
  initial: {
    x: -200,
    opacity: 0,
  },
  animate: {
    x: 0,
    opacity: 1,
  },
  exit: {
    x: -200,
    opacity: 0,
  },
};

export interface FilterProps {
  fields: IFormFields;
  defaultValues?: any;
  canReset?: boolean;
  isMobile?: boolean;
  isVisibleMobile?: boolean;
  onClose: () => void;
  reset?: () => void;
  onSubmit: SubmitHandler<any>;
}

export const Filter: React.FC<FilterProps> = ({
  isMobile,
  isVisibleMobile,
  canReset,
  fields,
  defaultValues,
  onClose,
  reset,
  onSubmit,
}) => {
  const ref = useRef<HTMLDivElement>(null);
  const [triggerSubmit, setTriggerSubmit] = useState(false);

  useEffect(() => {
    if (ref?.current) ref.current.scrollTop = 0;
  }, [ref, isVisibleMobile]);

  const triggerMobileSubmit = () => {
    setTriggerSubmit(true);
  };

  const handleOnSubmit = (data: any) => {
    onSubmit(data);
    setTriggerSubmit(false);
  };

  return (
    <AnimatePresence>
      {(!isMobile || isVisibleMobile) && (
        <FilterContainer key="filter" {...(isMobile ? mobileFilterAnimationProps : {})}>
          <FilterHeader>
            <Label>{copy.filter.title}</Label>
            <StyledCloseButton onClick={onClose} />
          </FilterHeader>
          <FilterContent ref={ref}>
            {reset && (
              <FilterReset onClick={reset} isVisible={canReset && !!reset}>
                {copy.form.resetAll}
              </FilterReset>
            )}
            <FormBuilder
              fields={fields}
              defaultValues={defaultValues}
              onSubmit={handleOnSubmit}
              buttons={{ primary: false }}
              triggerSubmit={triggerSubmit}
            />
          </FilterContent>
          <FilterFooter>
            <Button onClick={triggerMobileSubmit} isFullWidth type="submit">
              {copy.filter.apply}
            </Button>
          </FilterFooter>
        </FilterContainer>
      )}
    </AnimatePresence>
  );
};
